const fernet = require("../../node_modules/fernet/fernet")

const KEY = "pHI2lkUCaFHs5tMCX-hmthNb6o-6UddTBDxSWgniMCE="

export function symmetric_decrypt(message) {
  const secret = new fernet.Secret(KEY)
  const token = new fernet.Token({
    secret: secret,
    token: message,
    ttl: 0
  })
  return token.decode()
}

export function symmetric_encrypt(message) {
  const secret = new fernet.Secret(KEY)
  const token = new fernet.Token({
    secret: secret,
  })
  return token.encode(message)
}